module.exports = __webpack_public_path__ + "img/home-default-3.c53e030.png";